import React from 'react';
import {
  HomeContainer,
  MainContent,
  ImageWrapper,
  VideoWrapper,
  MottoSection,
  MottoSectionSpan,
} from './Home.styled';

const Home = () => {
  return (
    <HomeContainer>
      <MainContent>
        <ImageWrapper>
          <picture>
            <source
              media="(min-width:768px)"
              srcSet={'/images/cake-photo-d.png'}
            />
            <source
              media="(min-width:480px)"
              srcSet={'/images/cake-photo-t.png'}
            />
            <img src={'/images/cake-photo-m.png'} alt="cake" />
          </picture>
        </ImageWrapper>
        <MottoSection>
          <h1>
            Prăjituri făcute cu <MottoSectionSpan>dragoste</MottoSectionSpan>
          </h1>
        </MottoSection>
      </MainContent>
      <VideoWrapper>
        <video autoPlay loop muted>
          <source src={'/videos/video.mp4'} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </VideoWrapper>
    </HomeContainer>
  );
};

export default Home;
